"use client";

import { useEffect } from "react";
import { opensProductListAtTheList } from "./productListEntryScroll";
import { requestPlpHeaderScroll } from "./scrollToPlpHeader";

// Anything on the site can point at a filtered product list - a menu entry, a chip in
// a page header, a banner an editor pinned to a landing page, a link written inside a
// text block - so the request is recorded from one listener here rather than from each
// of the places a link can be written.
//
// Recording it on the click is what keeps it to links: a page opened from a search
// engine, or returned to with the back button, made no click and still starts where it
// should. The request also carries its own age, so one that never reached a list - a
// handler that opened a dialog instead, a navigation that took too long - is dropped
// rather than answered on some later page.
export default function ProductListLinkScroll() {
    useEffect(() => {
        const onClick = (event: MouseEvent) => {
            if (event.defaultPrevented) return;
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

            const anchor = (event.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
            // A link that opens in another tab or saves a file leaves this page alone.
            if (!anchor || (anchor.target && anchor.target !== "_self") || anchor.hasAttribute("download")) return;

            const href = anchor.getAttribute("href") ?? anchor.href;
            if (!opensProductListAtTheList(href, `${window.location.pathname}${window.location.search}`)) return;

            requestPlpHeaderScroll();
        };

        // Capture, so a link whose own handler takes the navigation over is still seen.
        document.addEventListener("click", onClick, true);
        return () => document.removeEventListener("click", onClick, true);
    }, []);

    return null;
}
